import React from 'react';
import styles from './PopularArticles.module.css';
import SubDiscipline from 'shared/components/SubDiscipline/SubDiscipline';
import OtvetyBanner from 'shared/components/OtvetyBanner/OtvetyBanner';

const ArticlesFromSubDiscipline = [
  {
    subDiscipline: 'Математика',
    articles: [
      { title: 'Уравнение', link: 'math/uravnenie' },
      {
        title: 'Таблица умножения',
        link: '/math/tablitsa_umnozheniya',
      },
      {
        title: 'Среднее арифметическое',
        link: '/math/srednee_arifmeticheskoe',
      },
      {
        title: 'Прямой угол',
        link: '/math/pryamoy_ugol',
      },
      {
        title: 'Треугольник',
        link: '/math/treugolnik',
      },
      {
        title: 'Окружность',
        link: '/math/okruzhnost',
      },
      {
        title: 'Параллельные прямые',
        link: '/math/parallelnye_pryamye',
      },
      {
        title: 'Основное свойство дроби',
        link: '/math/osnovnoe_svoystvo_drobi',
      },
      {
        title: 'Неправильные дроби',
        link: '/math/nepravilnye_drobi',
      },
      {
        title: 'Радиус',
        link: '/math/radius',
      },
    ],
  },
  {
    subDiscipline: 'Русский язык',
    articles: [
      {
        title: 'Грамматическая основа предложения',
        link: '/rus/grammaticheskaya_osnova_predlozheniya',
      },
      {
        title: 'Часть речи',
        link: '/rus/chast_rechi',
      },
      {
        title: 'Разбор слова по составу',
        link: '/rus/razbor_slova_po_sostavu_morfemnyy_razbor',
      },
      {
        title: 'Склонение имён существительных',
        link: '/rus/sklonenie_imyon_suschestvitelnyh',
      },
      {
        title: 'Синоним',
        link: '/rus/sinonim',
      },
    ],
  },
  {
    subDiscipline: 'Окружающий мир',
    articles: [
      {
        title: 'Экология',
        link: '/environment/ekologiya',
      },
      {
        title: 'Насекомые',
        link: '/environment/nasekomye',
      },
      {
        title: 'Среда обитания',
        link: '/environment/sreda_obitaniya',
      },
      {
        title: 'Круговорот воды в природе',
        link: '/environment/krugovorot_vody_v_prirode',
      },
      {
        title: 'Клетка',
        link: '/environment/kletka',
      },
    ],
  },
];

const PopularArticles = React.memo(() => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Популярное</p>
      <div className={styles.articles}>
        <SubDiscipline
          articles={ArticlesFromSubDiscipline[0].articles}
          title={ArticlesFromSubDiscipline[0].subDiscipline}
        />
        <SubDiscipline
          articles={ArticlesFromSubDiscipline[1].articles}
          title={ArticlesFromSubDiscipline[1].subDiscipline}
        />
        <SubDiscipline
          articles={ArticlesFromSubDiscipline[2].articles}
          title={ArticlesFromSubDiscipline[2].subDiscipline}
        />
      </div>
      <OtvetyBanner />
    </div>
  );
});

PopularArticles.displayName = 'PopularArticles';

export default PopularArticles;
